<template>
  <div class="mypage-current-plan-section">
    <h4 class="mypage-current-plan-section__title">
      {{ $tc('MypagePage.MypageContract.detailsPage.currentPlan') }}
    </h4>
    <div class="mypage-current-plan-section__plan">
      {{ currentPlanName }}
      <p v-if="contractTerm" class="mypage-current-plan-section__coupon-period">
        {{ couponExpirationDateText }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from '@vue/composition-api'
import { ContractTermType } from '@/store/stores/collectionModule/documents/GeneralTypes'
import I18n from '@/locales/I18n'
import useDisplayDependingOnLang from '@/components/hook/useDisplayDependingOnLang'

/**
 * マイページ: 契約情報 現在のプラン セクション
 */
export default defineComponent({
  name: 'MypageCurrentPlanSection',
  props: {
    currentPlanName: {
      type: String,
      default: '',
    },
    /**
     * 契約中のプランの契約期間
     */
    contractTerm: {
      type: Object as PropType<ContractTermType>,
      default: null,
    },
  },
  setup(props) {
    const { getDisplayDateTime } = useDisplayDependingOnLang()
    /**
     * クーポンの有効期限
     * クーポンプラン契約中の場合、contractTermが親から渡ってくる
     */
    const couponExpirationDateText = computed(() => {
      if (!props.contractTerm || !props.contractTerm.contractEndDate) return ''

      const endDate = getDisplayDateTime(props.contractTerm.contractEndDate)
      return `${I18n.t('MypagePage.MypageContract.detailsPage.couponContractTerm', {
        endDate,
      }).toString()}`
    })

    return {
      couponExpirationDateText,
    }
  },
})
</script>

<style lang="scss" scoped>
.mypage-current-plan-section {
  display: flex;
  flex-flow: row wrap;
  gap: 12px;
  width: 100%;
  padding: 0 16px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  letter-spacing: 0.02em;
  font-feature-settings: 'palt' on;
  color: $black;
  text-align: left;

  &__title {
    width: 100%;
    font-weight: 700;
  }

  &__plan {
    width: 100%;
    padding-bottom: 13px;
    color: $black20;
    border-bottom: 1px solid $black10;
  }

  &__coupon-period {
    width: 100%;
    margin-top: 6px;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.67;
    letter-spacing: 0.02em;
    font-feature-settings: 'palt' on;
    color: $gray75;
  }
}
</style>
